import React, { useState, useEffect } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn';
import { useMsal } from '@azure/msal-react';
import { useHistory } from 'react-router-dom';
import PageSubTitle from '../../component/Common/PageSubTitle';
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import { useLooksUpData } from '../../utils/getLookupTableData';
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'

const HealthQualityScore = () => {
    const [isLoading, setIsLoading] = useState(false)
    const gridStyle = { minHeight: 622, width: '100%' };
    const [gridRef, setGridRef] = useState(null as any)
    const history = useHistory()

    const ReportHeaders: any[] = [
        {
            name: 'measure_name',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Measure
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'description',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Description
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'metric',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Metric
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'source',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Source
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'effective_from_date',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Effective From Date
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
        {
            name: 'trend',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Trend
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 150
        },
    ]

    const reportResponseList = [
       
        {
            key: 1,
            measure_name: 'Network PCP Adequacy Score',
            description: 'Number of PCPs available within 30 minutes distance',
            metric: 'Availability of 2-3 PCPs within 30 minutes of travel time',
            source: 'Plans Provider Network and Provider Network changes',
            effective_from_date: '1/1/2023',
            trend: ''
        },
       
       {
            key: 2,
            measure_name: 'Claims Adjudication Timeliness',
            description: 'Data related to claims received and processed by the plans',
            metric: '95% within 15 days',
            source: 'Monthly Medical Claims Report, Pharmacy Claims Report',
            effective_from_date: '1/1/2023',
            trend: ''
        },
    ];

    const filterValue =
        [
            { name: 'measure_name', operator: 'contains', type: 'string', value: '' },
            { name: 'description', operator: 'contains', type: 'string', value: '' },
            { name: 'metric', operator: 'contains', type: 'string', value: '' },
            { name: 'source', operator: 'contains', type: 'string', value: '' },
            { name: 'effective_from_date', operator: 'contains', type: 'string', value: '' }
        ]

    const handleRowClick = (data: any) => {
        // if (!checkAccess('report_inventory_listpage', 'NOAC')) {
        // history.push({
        //     pathname: '/',
        //     state: { recordData: data }
        // });
        // }
    }

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="Health Quality Scores" />
                </div>
            </div>

            <div className="form-layout">
                {isLoading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading.....</p>
                    </div>
                ) :
                    <>
                        <ReactDataGrid
                            licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                            idProperty="key"
                            style={gridStyle}
                            pagination
                            virtualized
                            columns={ReportHeaders}
                            dataSource={reportResponseList}
                            sortable={true}
                            // onFilterValueChange={handleFilterChangeGrid}
                            defaultLimit={10}
                            defaultFilterValue={filterValue}
                            rowHeight={50}
                            onRowClick={({ data }) => handleRowClick(data)}
                            className="pointer-cursor-row"
                            // loading={isFilesGridLoading}
                            enableColumnAutosize={true}
                            handle={setGridRef}
                            pageSizes={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                        />

                    </>
                }
            </div>

            <Footer />
        </>
    );
};

export default HealthQualityScore;